import { useOrganization } from '@clerk/clerk-react';

/**
 * Checks if the current organization member has a specific role.
 * @param {string} roleToCheck - e.g., 'org:admin'
 * @returns {boolean}
 */
export function useHasClerkRole(roleToCheck: string) {
  const { membership, isLoaded } = useOrganization();

  if (!isLoaded || !membership) return false;

  return membership.role === roleToCheck;
}
